export default "__VITE_ASSET__CpAs8DLy__"